import { render, staticRenderFns } from "./HeadCountReportDetails.vue?vue&type=template&id=41c10eca"
import script from "./HeadCountReportDetails.vue?vue&type=script&lang=js"
export * from "./HeadCountReportDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports